import { render, staticRenderFns } from "./masrafmerkezi.vue?vue&type=template&id=1eebad17&"
import script from "./masrafmerkezi.vue?vue&type=script&lang=js&"
export * from "./masrafmerkezi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports